export const TYPOGRAPHY = {
	fontFamily:
		"'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
	weights: {
		regular: 400,
		medium: 500,
		semibold: 600,
		bold: 700,
	},
	display: {
		fontSize: '56px',
		fontWeight: 700,
		lineHeight: 1.04,
	},
	h1: {
		fontSize: '36px',
		fontWeight: 700,
		lineHeight: 1.12,
	},
	h2: {
		fontSize: '30px',
		fontWeight: 600,
		lineHeight: 1.16,
	},
	h3: {
		fontSize: '24px',
		fontWeight: 600,
		lineHeight: 1.22,
	},
	h4: {
		fontSize: '20px',
		fontWeight: 600,
		lineHeight: 1.28,
	},
	title: {
		fontSize: '18px',
		fontWeight: 600,
		lineHeight: 1.35,
	},
	body: {
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: 1.55,
	},
	bodySmall: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: 1.45,
	},
	caption: {
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: 1.35,
	},
	button: {
		fontSize: '15px',
		fontWeight: 600,
		lineHeight: 1.2,
	},
	label: {
		fontSize: '13px',
		fontWeight: 500,
		lineHeight: 1.35,
	},
};

export default TYPOGRAPHY;
